import "./AbTestStyles.css";
import AbTestDataBox from "./AbTestDataBox";
import { useEffect, useState, useContext } from "react";
import { uploadFileToFirestorePublicCached } from "../../helpers";
import { SelectedProjectContext } from "../../contexts";

const AbTestStep2Image = ({ setActiveTab, selectedTest, setSelectedTest }) => {
  const selectedProject = useContext(SelectedProjectContext);
  const [selectedImage, setSelectedImage] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [imgSizeWarning, setImgSizeWarning] = useState("");
  const [oldSrc, setOldSrc] = useState(selectedTest.element.data);

  useEffect(() => {
    const body =
      "Please be aware that uploading an image of a different size risks layout shifts or warping.";
    const img = new Image();
    img.src = oldSrc;

    img.onload = () => {
      setImgSizeWarning(
        `Your image is ${img.naturalWidth}x${img.naturalHeight}px. ${body}`,
      );
    };

    img.onerror = () => {
      setOldSrc(selectedTest.oldSrc);
      setImgSizeWarning(
        `We could not measure the size of the original image. ${body}`,
      );
    };
  }, [oldSrc]);

  async function handleImageUpload(file) {
    const timestamp = Date.now();
    const fileExtension = file.name.split(".").pop();
    const newFileName = `${selectedProject.value.slice(-5)}_${timestamp.toString().slice(-6)}.${fileExtension}`;
    const renamedFile = new File([file], newFileName, { type: file.type });
    const imageLink = await uploadFileToFirestorePublicCached(
      "public",
      renamedFile,
    );
    setSelectedTest((prev) => ({ ...prev, data: imageLink }));
    setActiveTab(3);
  }

  // Handle image upload
  useEffect(() => {
    if (!selectedImage) {
      setImagePreview(undefined);
      return;
    }
    const imageUrl = URL.createObjectURL(selectedImage);
    setImagePreview(imageUrl);

    // Free memory whenever this component is unmounted
    return () => URL.revokeObjectURL(imageUrl);
  }, [selectedImage]);

  const onSelectImage = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedImage(undefined);
      return;
    }

    setSelectedImage(e.target.files[0]);
    handleImageUpload(e.target.files[0]);
  };

  const content =
    imagePreview || selectedTest.data ? (
      <div className="mb-12 mt-16">
        <img
          className="abtest-img-limit"
          src={imagePreview || selectedTest.data}
        ></img>
      </div>
    ) : (
      <div className="mb-12 mt-16">
        <button
          className="btn-primary"
          onClick={() => document.getElementById("image-upload").click()}
        >
          Upload
        </button>
      </div>
    );

  return (
    <div>
      <div className="abtest-info-block mb-50">
        <div> Change the content you want to test.</div>
        <div>{imgSizeWarning}</div>
      </div>
      <div className="d-flex">
        <div className="abtest-step2-left">
          <div className="mb-100">
            <div className="fw-700 fs-18 fc-black mb-20">Element to change</div>
            <div className="mb-10">
              <AbTestDataBox
                type="faded"
                header="Nature of the element"
                content="Image"
              />
            </div>
            <div>
              <AbTestDataBox
                type="active"
                header="Image"
                content={
                  <div className="mb-12 mt-16">
                    <img
                      className="abtest-img-limit"
                      src={oldSrc}
                      alt="Your website may have a mechanism in place that blocks us from retrieving your images."
                    ></img>
                  </div>
                }
              />
            </div>
          </div>
        </div>

        <div className="abtest-step2-right">
          <div className="fw-700 fs-18 fc-black">New version</div>
          <div className="mt-92">
            <AbTestDataBox type="active" header="Image" content={content} />
            <input
              type="file"
              id="image-upload"
              style={{ display: "none" }}
              onChange={onSelectImage}
              accept=".jpeg, .jpg, .png, .gif, .webp"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AbTestStep2Image;
